import { memo, useEffect, useMemo, useState } from 'react'
import IconBtn from './controls/IconBtn'
import '../css/WorkCard.css'

const WorkCard = memo(({ openModal, work }) => {
  const [showExtendedDetails, setShowExtendedDetails] = useState(false)

  const onImageClick = e => openModal(e, work)

  const onShowExtendedDetails = e => {
    e.preventDefault()
    setShowExtendedDetails(prev => !prev)
  }

  useEffect(
    work => {
      if (!work) return
      const workCard = document.querySelector(`#card${work.id}`)
      workCard.classList && workCard.classList.remove('appear')
    },
    [work],
  )

  const detailsProps = useMemo(
    () => ({
      isaction: 'true',
      path: showExtendedDetails ? 'FaRegListAlt' : 'FaListAlt',
      target: '',
      title: 'Project details',
    }),
    [showExtendedDetails],
  )

  const image = work?.preview || work?.media?.images?.[0] || '/static/images/fallback.webp'
  return (
    <article id={`card${work.id}`} className='card appear'>
      <img alt={`preview of ${work.title}`} className={`mediaContainer ${showExtendedDetails ? ' showExtendedDetails' : ''}`} src={image} onClick={onImageClick} loading='lazy' decoding='async'></img>
      <div className={`detailContainer ${showExtendedDetails ? ' showExtendedDetails' : ''}`}>
        <h2 className='title'>{work.title || ''}</h2>
        <p className='tech'>{work.tech?.join(' • ') || 'example tech'}</p>
        <p className='description'>{work.description}</p>
        <section className={`extendedDetails ${showExtendedDetails ? ' showExtendedDetails' : ''}`}>
          {work?.details?.length > 0 && work.details.map((d, i) => <p key={`ed${i}`}>{d}</p>)}
        </section>
      </div>

      <div className='icons'>
        <IconBtn propOverrides={detailsProps} clickhandler={onShowExtendedDetails} work={work} />
        {work.links &&
          work.links.map(link => (
            <IconBtn key={link.title} propOverrides={link} clickhandler={openModal} work={work} />
          ))}
      </div>
    </article>
  )
})

export default WorkCard
